import styles from './Tab.module.scss';
import LogoDecatron from '../../assets/icons/logo_decatron.png';
import BackIcon from '../../assets/icons/back-icon.png';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ServiceKeys } from '../../interfaces/IServices';

interface ITabProps {
    onServiceClick: (service: ServiceKeys) => void;
}

export default function Tab({ onServiceClick }: ITabProps) {
    const [activeTab, setActiveTab] = useState('DATACENTER');
    const tabs = ['datacenter', 'redes', 'segurança'] as const;

    const navigate = useNavigate();

    const handleClick = (service: ServiceKeys) => {
        onServiceClick(service);
        setActiveTab(service);
    };

    const capitalize = (word: string) => {
        return `${word.slice(0, 1).toUpperCase()}${word.slice(1)}`;
    };

    return (
        <section className={styles.tabs_container}>
            <div className={styles.tabs_logo_box}>
                <img src={LogoDecatron} alt="Logo Decatron" />
            </div>

            <div className={styles.box_tab}>
                <div className={styles.back_box} onClick={() => void navigate('/home')}>
                    <img src={BackIcon} alt="voltar" />
                    <p>Home</p>
                </div>

                <div className={styles.tabContainer}>
                    {tabs.map((tab) => (
                        <div
                            key={tab}
                            className={`${styles.tab} ${activeTab === tab ? styles.active : ''}`}
                            onClick={() => handleClick(tab)}
                        >
                            {capitalize(tab)}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
